const SwitcherArrow = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M2.95388 5.67461C3.13359 5.46495 3.44924 5.44067 3.6589 5.62038L8.00017 9.34147L12.3414 5.62038C12.5511 5.44067 12.8668 5.46495 13.0465 5.67461C13.2262 5.88428 13.2019 6.19993 12.9922 6.37964L8.32557 10.3796C8.13832 10.5401 7.86202 10.5401 7.67478 10.3796L3.00811 6.37964C2.79845 6.19993 2.77417 5.88428 2.95388 5.67461Z" fill="#1C225A"/>
        </svg>
    )
}

export default SwitcherArrow